import axiosInstance, { endpoints } from "../../lib/axios";
import { LöneResponse } from "../../types/nya/ekonomi/loner/LoneTyper";
import { useSetState } from "src/hooks/use-set-state";
import { OrganisationState } from "src/context/organisation-context";
import { IOrganisation, IRäkenskapsår } from "../../types/nya/common";
import { medOrgHuvud } from 'src/lib/org-huvud';


export function HämtaMatchningarAvLöner(organisation: IOrganisation | null, rakenskapsar?: IRäkenskapsår | null): Promise<LöneResponse> {
  const orgId = organisation?.id;
  if (!orgId) {
    return Promise.reject("Ingen organisation vald");
  }

  const body: any = {
    orgId: orgId,
  };
  if (rakenskapsar) {
    body.rakenskapsar = rakenskapsar;
  }
  return axiosInstance.post(endpoints.lön.root + "/" + orgId, body)
    .then(response => {
      return response.data
    })
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function HämtaLöntagare(orgId: string): Promise<any[]> {
  return axiosInstance.get(endpoints.lön.root + "/lontagare/" + orgId, medOrgHuvud(orgId))
    .then(response => response.data)
    .catch(error => { throw error; });
}

export function HämtaFlerBanktransaktioner(orgId: string, matchningId: string): Promise<any[]> {
  return axiosInstance.get(endpoints.lön.root + `/${orgId}/matchning/${matchningId}/fler-transaktioner`)
    .then(response => response.data)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function HämtaFlerBanktransaktionerIPeriod(orgId: string, matchningId: string, månader: number = 6): Promise<any[]> {
  return axiosInstance
    .get(endpoints.lön.root + `/${orgId}/matchning/${matchningId}/fler-transaktioner-i-period`, {
      params: { månader },
    })
    .then(response => response.data)
    .catch(error => {
      console.error(error);
      throw error;
    });
}
export function SkapaDefaultLöntagare(orgId: string, löntagare: any): Promise<any> {
    return axiosInstance.post(endpoints.lön.root + "/lontagare/default/" + orgId, löntagare)
        .then(response => response.data);
}
export function SparaMatchningAvLön(orgId: string, matchning: any): Promise<any> {
    return axiosInstance.post(endpoints.lön.root + "/matchning/spara/" + orgId, matchning)
        .then(response => response.data);
}

export function RaderaMatchningAvLön(orgId: string, matchningId: string): Promise<any> {
    return axiosInstance.post(endpoints.lön.root + `/matchning/radera/${orgId}/${matchningId}`)
        .then(response => response.data);
}

export function RaderaAllaMatchningar(orgId: string): Promise<any> {
    return axiosInstance.post(endpoints.lön.root + `/matchning/radera-alla/${orgId}`)
        .then(response => response.data);
}
